import FilterIcon from "../shared/FilterIcon";
import { FilterColumnProps } from "../types";

interface FilterChipProps {
    column: FilterColumnProps;
    selected: boolean;
    onClick: () => void;
    disabled?: boolean;
}

const selectedClasses = 'text-primary-100 border border-brand-green-30 bg-brand-green-30'
const unselectedClasses = 'border border-primary-10 text-brand-green-30'
const disabledClasses = 'border border-[#49454F]/25 text-system-light-100/20'

const getImgClassName = (selected: boolean, disabled: boolean) => {
    if (disabled) return 'opacity-20'
    return selected ? 'brightness-0 invert' : ''
}

const getChipClasses = (selected: boolean, disabled: boolean) => {
    if (disabled) return disabledClasses
    return selected ? selectedClasses : unselectedClasses
}

const FilterChip = ({ column, selected, onClick, disabled = false }: FilterChipProps) => {
    const { title, icon, selectedValues } = column
    return (
        <button
            title={title}
            className={`flex items-center gap-2 shrink-0 whitespace-nowrap text-llarge px-4 py-1 rounded-full ${getChipClasses(selected, disabled)}`}
            disabled={disabled}
            aria-pressed={selected}
            onClick={onClick}
        >
            <FilterIcon icon={icon} size={18} imgSize={16} imgClassName={getImgClassName(selected, disabled)} />
            {title}
            {selectedValues.length > 0 &&
                <p className='bg-brand-orange-30 rounded-lg px-2 h-[1rem] text-lsmall text-primary-100'>{selectedValues.length}</p>
            }
        </button>
    )
}

export default FilterChip